import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const OptionSourceForm = ({ idx, onChange, onValidate, source, validationState }) => {
  const sourceTypes = usePluginEntities("views.parameters.option.sources");
  if (!(source == null ? void 0 : source.type)) {
    return null;
  }
  const { editComponent: EditComponent } = sourceTypes.find(({ type }) => type === source.type);
  return /* @__PURE__ */ React.createElement(
    EditComponent,
    {
      idx,
      source,
      validationState,
      onChange,
      onValidate
    }
  );
};
export default OptionSourceForm;
